/* eslint-disable */
export default {
  forward: 'Desviar',
  reply: 'Responder',
  ignore: 'Ignorar',
  toVoicemail: 'Al buzón de voz',
  answer: 'Responder',
  answerAndEnd: 'Responder y finalizar',
  answerAndHold: 'Responder y poner en espera',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"answerAndEnd"@#@ @source: @#@"Answer & End"@#@
// @key: @#@"answerAndHold"@#@ @source: @#@"Answer & Hold"@#@
